import React, { Component } from 'react';
import { fetchData } from '../lib/apis';
import { DateRangePicker, LanguageType } from 'react-date-range';
import * as rdrLocales from 'react-date-range/dist/locale';
import { Tooltip, Popover, Row, Col, Input, Button, Form, Radio, Select, Checkbox, Modal, DatePicker } from 'antd';
import ContentFilterPost from './popup-filter-post';

import { WidgetChatImportCustomer, WidgetBooking, WidgetFormCareHandle } from './index';
import config from '../lib/config';

import { 
    HiOutlineChatAlt2, 
    HiOutlineBookmark, 
    HiOutlineChat, 
    HiOutlinePaperAirplane, 
    HiOutlinePhone, 
    HiOutlineCalendar, 
    HiOutlineDocumentText, 
    HiOutlineUserGroup,
    HiOutlineUpload,
    HiOutlineCheckCircle,
    HiOutlineStatusOnline,
    HiOutlineSearch,
    HiOutlineChartPie
} from 'react-icons/hi';

export default class SideBarFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_filter: [],
            dateRangePickerI: {
                selection: {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',
                }
            },
            typeView: this.props.typeView,
            listPosts: [],
            staff: [],
            listStaff: []
        }
        this.hideFiltrerPost = this.hideFiltrerPost.bind(this);
        this.selectFilterPost = this.selectFilterPost.bind(this);
        this.refFilterDate = null;
        this.mouseEnterDelay = 0.02;
        this.mouseLeaveDelay = 0.03;
        this.pageListPost = 1;
        this.nextPageListPost = true;
        this.limitPost = 20;
    }
    componentWillMount() {

    }
    componentWillReceiveProps(nextProps) {
        if (this.state.typeView != nextProps.typeView) {
            this.setState({
                data_filter: [],
                dateRangePickerI: {
                    selection: {
                        startDate: new Date(),
                        endDate: new Date(),
                        key: 'selection',
                    }
                },
                typeView: nextProps.typeView,
                startDate: '',
                endDate: '',
                post_id: null
            })
        }
    }
    handleDataFilter = (filter, e, nochange) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        let data_filter = this.state.data_filter;
        if (filter) {
            if (!nochange) {
                if (data_filter.indexOf(filter) == -1) {
                    data_filter.push(filter);
                } else {
                    data_filter.splice(this.state.data_filter.indexOf(filter), 1);
                }
            }
        } else {
            data_filter = [];
        }
        this.setState({
            data_filter: data_filter
        }, () => {
            let data_filter_obj = [];
            data_filter.forEach((item, i) => {
                switch (item) {
                    case 1:
                        data_filter_obj.push('read_state=1')
                        break;
                    case 4:
                        data_filter_obj.push('phone_is=true')
                        break;
                    default:
                    // code block
                }
            })
            if (data_filter.indexOf(2) != -1 && data_filter.indexOf(3) != -1) {
                data_filter_obj.push('type=comment,direct');
            } else if (data_filter.indexOf(2) != -1) {
                data_filter_obj.push('type=comment');
            }
            else if (data_filter.indexOf(3) != -1) {
                data_filter_obj.push('type=direct');
            }
            if (data_filter.indexOf(6) != -1) {
                data_filter_obj.push(`start_date=${this.state.startDate}`);
                data_filter_obj.push(`end_date=${this.state.endDate}`);
            }
            if (data_filter.indexOf(7) != -1 && this.state.post_id) {
                data_filter_obj.push(`media_id=${this.state.post_id}`);
            }
            if (data_filter.indexOf(8) != -1) {
                let values = this.formFilterOther.getFieldsValue();
                Object.keys(values).forEach((key) => {
                    if (values[key]) data_filter_obj.push(`${key}=${values[key]}`)
                })
            }
            if (this.props.handleFilter) {
                this.props.handleFilter(data_filter_obj.join("&"));
            }
        })

    }
    handleRangeChange(which, payload) {
        this.setState({
            [which]: {
                ...this.state[which],
                ...payload,
            },
        });
    }
    handleShowFilterDate = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let domrect = e.target.getBoundingClientRect();
        let domrect_filterdate = this.refFilterDate.getBoundingClientRect();

        let data_filter = this.state.data_filter;
        if (data_filter.indexOf(6) == -1) {
            data_filter.push(6);
        } else {
            data_filter.splice(this.state.data_filter.indexOf(6), 1);
        }
        this.setState({
            showFilterDate: !this.state.showFilterDate,
            data_filter: data_filter,
            posFilterDate: {
                left: domrect.right + 10,
                top: 100
            }
        })
    }
    filterDate = (action) => {
        let data_filter = this.state.data_filter;
        if (action) {
            if (data_filter.indexOf(6) == -1) {
                data_filter.push(6);
            }
            this.setState({
                showFilterDate: false,
                startDate: new Date(this.state.dateRangePickerI.selection.startDate).getTime(),
                endDate: new Date(this.state.dateRangePickerI.selection.endDate).getTime() + (60 * 1000 * 60 * 24),
                data_filter: data_filter,
                visibleFilterDate: false
            }, () => {
                this.handleDataFilter(true);
            })
        } else {
            if (data_filter.indexOf(6) != -1) {
                data_filter.splice(data_filter.indexOf(6), 1);
            }
            this.setState({
                showFilterDate: false,
                data_filter: data_filter,
                visibleFilterDate: false
            }, () => {
                this.handleDataFilter(true);
            })
        }
    }
    componentWillUnmount = () => {
        this.setState({
            data_filter: []
        })
    }
    filterPost = async (e) => {
        if (e) {
            try {
                let user_owners = this.props.userOwnerFilter ? this.props.userOwnerFilter : [];
                this.pageListPost = 1;
                let posts = await fetchData({
                    url: `api/v1/post/list?limit=${this.limitPost}&user_owners=${user_owners.join(',')}`
                })
                this.setState({
                    visibleFilterPost: true,
                    listPosts: posts.data
                })
                if (posts.data.length != this.limitPost) return this.nextPageListPost = false;
                this.nextPageListPost = true;
            } catch (err) {
                console.log(err);
            }
        } else {
            this.setState({
                visibleFilterPost: false
            })
        }
    }
    getPost = async () => {
        if (!this.nextPageListPost) return;
        this.pageListPost++;
        try {
            let user_owners = this.props.userOwnerFilter ? this.props.userOwnerFilter : [];
            let posts = await fetchData({
                url: `api/v1/post/list?limit=${this.limitPost}&page=${this.pageListPost}&user_owners=${user_owners.join(',')}`
            })
            if (posts.data.length != this.limitPost) this.nextPageListPost = false;

            let listPosts = this.state.listPosts;
            listPosts = listPosts.concat(posts.data);
            this.setState({
                listPosts: listPosts
            })
        } catch (err) {
            console.log(err);
        }
    }
    hideFiltrerPost = () => {
        let data_filter = this.state.data_filter;
        if (data_filter.indexOf(7) != -1) {
            data_filter.splice(data_filter.indexOf(7), 1);
            this.setState({
                visibleFilterPost: false,
                data_filter: data_filter,
                post_id: ''
            }, () => {
                this.handleDataFilter(true);
                this.pageListPost = 1;
                this.nextPageListPost = true;
            })
        } else {
            this.setState({
                visibleFilterPost: false,
                data_filter: data_filter
            })
        }

    }
    selectFilterPost = (post) => {
        let data_filter = this.state.data_filter;
        if (data_filter.indexOf(7) == -1) {
            data_filter.push(7);
        }
        this.setState({
            visibleFilterPost: false,
            data_filter: data_filter,
            post_id: post.media_id
        }, () => {
            this.handleDataFilter(true);
        })
    }
    getListStaff = (e) => {
        try {
            if (this.timeout) clearTimeout(this.timeout);
            this.setState({ loadingGetStaff: true })
            this.timeout = setTimeout(async () => {
                let response = await this.props.fetchData({
                    url: `api/v1/chat/staff/list?limit=10&fullname=${e}`
                })
                this.setState({
                    listStaff: response.data,
                    loadingGetStaff: false
                })
            }, 300);
        } catch (err) {
            this.setState({ loadingGetStaff: false })
            this.props.notification({
                title: "Tìm nhân viên",
                content: err.message || "Đã có lỗi xảy ra!",
                type: "error"
            })
        }
    }
    render() {
        const renderSidebarItem = (label, active, icon, type, props = {}) => {
            const className = [active ? "sidebar-selected" : "", type, props.className || ""].filter(Boolean).join(" ");
            return (
                <li {...props} className={className}>
                    <span className="sidebar-icon">{icon}</span>
                    <span className="sidebar-label">{label}</span>
                </li>
            );
        };
        const tagFavourites = this.props.settingSystem ? this.props.settingSystem.tags.filter((item) => item.is_favourite) : [];

        const formFilterAdv = <Form
            layout="vertical"
            onFinish={(values) => {
                this.handleDataFilter(8);
                this.setState({ visibleFilterOther: false });
            }}
            ref={(ref) => this.formFilterOther = ref}
            className="form-filter-other"
            initialValues={{
                care_handle_id: null,
                phone: '',
                is_phone: false
            }}
        >
            <Form.Item name="is_phone" label="Tìm kiếm khách hàng" valuePropName="checked">
                <Checkbox>Chỉ tìm khách hàng có số điện thoại</Checkbox>
            </Form.Item>
            <Form.Item name="phone" label="Số điện thoại">
                <Input placeholder="Nhập số điện thoại" />
            </Form.Item>
            <Form.Item name="care_handle_id" label="Nhân viên chăm sóc">
                <Select
                    showSearch
                    placeholder="Chọn nhân viên"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    allowClear
                >
                    {(this.state.listStaff || []).map((staff) => (
                        <Select.Option key={staff.staff_id} value={staff.staff_id}>
                            {staff.staff_name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <div className="action-btn">
                <Button onClick={() => {
                    this.formFilterOther.resetFields();
                    this.handleDataFilter(false);
                    this.setState({ visibleFilterOther: false });
                }}>Bỏ lọc</Button>
                <Button type="primary" htmlType="submit">Lọc</Button>
            </div>
        </Form>;

        const formFilterDate = <div className="form-filter-date">
            <DatePicker.RangePicker
                showTime
                format="HH:mm DD/MM/YYYY"
                onChange={(dates) => this.setState({ filterDateRange: dates })}
                value={this.state.filterDateRange}
            />
            <div className="action-btn">
                <Button onClick={() => this.filterDate(false)}>Bỏ lọc</Button>
                <Button type="primary" onClick={() => this.filterDate(true)}>Lọc</Button>
            </div>
        </div>;

        return (
            <div id="sidebar-filter" className={`${this.props.contactIdSelected ? 'chat-view' : ''} ${this.props.UserLogin.is_offline == 1 ? "chat-offline" : ""} ${this.props.displayMobile ? 'mobile-sidebar-filter' : ''}`}
                style={{
                    marginTop: `${this.props.statusBarHeight}px`
                }}
            >
                <div className="overlay" onClick={() => {
                    document.querySelector('#sidebar-filter').classList.remove('show');
                }}></div>
                <div id="filter-post"></div>

                <WidgetChatImportCustomer visible={this.state.visibleImportCustomer} hide={() => this.setState({ visibleImportCustomer: false })} onFinish={() => this.handleDataFilter(true)} />
                <WidgetBooking
                    visible={this.state.visibleBooking}
                    hide={() => this.setState({ visibleBooking: false })}
                    onFinish={() => this.handleDataFilter(true)}
                    treeDataService={this.props.treeDataService}
                    companySelected={this.props.companySelected}
                    UserLogin={this.props.UserLogin}
                    treeDataDoctor={this.props.treeDataDoctor}
                />

                <WidgetFormCareHandle visible={this.state.visibleCareHandle} hide={() => this.setState({ visibleCareHandle: false })} 
                    handleOffline={this.props.handleOffline}
                />

                <div className={this.props.displayMobile ? "mobile-sheet-content" : ""}>
                    {
                        this.props.displayMobile ? <div className="mobile-filter-sheet-header">
                            <div className="sheet-handle"></div>
                            <div className="sheet-title-row">
                                <div>
                                    <div className="sheet-title">Bộ lọc hội thoại</div>
                                    <div className="sheet-subtitle">Tìm kiếm và lọc danh sách chat.</div>
                                </div>
                                <button
                                    type="button"
                                    className="sheet-close"
                                    onClick={() => {
                                        const filterNode = document.querySelector('#sidebar-filter');
                                        if (filterNode) filterNode.classList.remove('show');
                                    }}
                                >
                                    Đóng
                                </button>
                            </div>
                            <div className="mobile-filter-search">
                                <div className="mobile-filter-search-container">
                                    <HiOutlineSearch className="search-icon" size={20} />
                                    <input
                                        id="input-search-contact-mobile"
                                        placeholder="Tìm kiếm hội thoại"
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter' && this.props.handleSearchKeyword) {
                                                this.props.handleSearchKeyword(e.target.value, true, false);
                                            }
                                        }}
                                        onChange={(e) => {
                                            if (!this.props.handleSearchKeyword) return;
                                            if (e.target.value.length == 0) {
                                                this.props.handleSearchKeyword(e.target.value)
                                            } else {
                                                this.props.handleSearchKeyword(e.target.value, false);
                                            }
                                        }}
                                        value={this.props.search_keyword || ''}
                                    />
                                </div>
                            </div>
                            {
                                tagFavourites.length > 0 ? <div className="mobile-filter-tags">
                                    {
                                        tagFavourites.map((item) => {
                                            const active = this.props.tagsFilter && this.props.tagsFilter.indexOf(item.tag_id) != -1;
                                            return (
                                                <button
                                                    type="button"
                                                    key={item.tag_id}
                                                    className={active ? 'active' : ''}
                                                    style={{ borderColor: item.tag_color, color: active ? '#ffffff' : item.tag_color, background: active ? item.tag_color : '#ffffff' }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (this.props.handleFilterTag) this.props.handleFilterTag({ tag_id: item.tag_id });
                                                    }}
                                                >
                                                    {item.tag_name}
                                                </button>
                                            );
                                        })
                                    }
                                </div> : null
                            }
                        </div> : null
                    }

                    <ul className="sidebar-nav">
                        {renderSidebarItem('Tất cả', this.state.data_filter.length == 0, <HiOutlineChatAlt2 size={24} />, 'filter-all', {
                            onClick: (e) => this.handleDataFilter(false, e)
                        })}
                        {renderSidebarItem('Chưa đọc', this.state.data_filter.indexOf(1) != -1, <HiOutlineBookmark size={24} />, 'filter-unread', {
                            onClick: (e) => this.handleDataFilter(1, e)
                        })}
                        {renderSidebarItem('Bình luận', this.state.data_filter.indexOf(2) != -1, <HiOutlineChat size={24} />, 'filter-comment', {
                            onClick: (e) => this.handleDataFilter(2, e)
                        })}
                        {renderSidebarItem('Tin nhắn', this.state.data_filter.indexOf(3) != -1, <HiOutlinePaperAirplane size={24} style={{ transform: 'rotate(45deg)' }} />, 'filter-message', {
                            onClick: (e) => this.handleDataFilter(3, e)
                        })}
                        {renderSidebarItem('Có số ĐT', this.state.data_filter.indexOf(4) != -1, <HiOutlinePhone size={24} />, 'filter-phone', {
                            onClick: (e) => this.handleDataFilter(4, e)
                        })}
                        {
                            !this.props.isAppNative ?
                                <Tooltip placement="right" title={'Lọc theo khoảng thời gian'} mouseEnterDelay={this.mouseEnterDelay} mouseLeaveDelay={this.mouseLeaveDelay}>
                                    <Popover
                                        content={formFilterDate}
                                        trigger="click"
                                        placement="right"
                                        onVisibleChange={(e) => {
                                            this.setState({ visibleFilterDate: e })
                                        }}
                                        visible={this.state.visibleFilterDate}
                                    >
                                        {renderSidebarItem('Thời gian', this.state.data_filter.indexOf(6) != -1, <HiOutlineCalendar size={24} />, 'filter-time')}
                                    </Popover>
                                </Tooltip> : <React.Fragment>
                                    <Modal
                                        title={'Lọc theo khoảng thời gian'}
                                        visible={this.state.visibleFilterDate}
                                        footer={null}
                                        onCancel={() => this.setState({ visibleFilterDate: false })}
                                        className="modal-h-antd modal-content-md"
                                        centered
                                    >
                                        {formFilterDate}
                                    </Modal>
                                    {renderSidebarItem('Thời gian', this.state.data_filter.indexOf(6) != -1, <HiOutlineCalendar size={24} />, 'filter-time', {
                                        onClick: () => this.setState({ visibleFilterDate: true })
                                    })}
                                </React.Fragment>
                        }
                        {
                            !this.props.isAppNative ?
                                <Tooltip placement="right" title={'Lọc theo bài viết'} mouseEnterDelay={this.mouseEnterDelay} mouseLeaveDelay={this.mouseLeaveDelay}>
                                    <Popover overlayClassName={'filter-post'} placement="right" title={'Lọc theo bài viết'}
                                        content={<ContentFilterPost
                                            hideFiltrerPost={this.hideFiltrerPost}
                                            data={this.state.listPosts}
                                            selectFilterPost={this.selectFilterPost}
                                            getPost={this.getPost}
                                        />} trigger="click"
                                        onVisibleChange={(e) => this.filterPost(e)}
                                        visible={this.state.visibleFilterPost}
                                    >
                                        {renderSidebarItem('Bài viết', this.state.data_filter.indexOf(7) != -1, <HiOutlineDocumentText size={24} />, 'filter-post')}
                                    </Popover>
                                </Tooltip> : <React.Fragment>
                                    <Modal
                                        title={'Lọc theo bài viết'}
                                        visible={this.state.visibleFilterPost}
                                        footer={null}
                                        onCancel={() => this.setState({ visibleFilterPost: false })}
                                        className="modal-h-antd modal-content-md filter-post"
                                        centered
                                    >
                                        <ContentFilterPost
                                            hideFiltrerPost={this.hideFiltrerPost}
                                            data={this.state.listPosts}
                                            selectFilterPost={this.selectFilterPost}
                                            getPost={this.getPost}
                                        />
                                    </Modal>
                                    {renderSidebarItem('Bài viết', this.state.data_filter.indexOf(7) != -1, <HiOutlineDocumentText size={24} />, 'filter-post', {
                                        onClick: (e) => this.setState({
                                            visibleFilterPost: true
                                        }, () => {
                                            this.filterPost(e);
                                        })
                                    })}
                                </React.Fragment>
                        }
                        {
                            this.props.UserLogin.role_company.indexOf('sale') == -1 ?
                                <React.Fragment>
                                    {
                                        !this.props.isAppNative ? <Tooltip placement="right" title={'Lọc nâng cao'} mouseEnterDelay={this.mouseEnterDelay} mouseLeaveDelay={this.mouseLeaveDelay}>
                                            <Popover placement="right" title={'Lọc nâng cao'}
                                                content={
                                                    <div style={{ width: "360px" }}>
                                                        {formFilterAdv}
                                                    </div>
                                                } trigger="click"
                                                onVisibleChange={(e) => this.setState({ visibleFilterOther: e }, () => {
                                                    if (e) this.getListStaff("");
                                                })}
                                                visible={this.state.visibleFilterOther}
                                            >
                                                {renderSidebarItem('Nâng cao', this.state.data_filter.indexOf(8) != -1, <HiOutlineUserGroup size={24} />, 'filter-adv')}
                                            </Popover>
                                        </Tooltip> : <React.Fragment>
                                            <Modal
                                                title={'Lọc nâng cao'}
                                                visible={this.state.visibleFilterOther}
                                                footer={null}
                                                onCancel={() => this.setState({ visibleFilterOther: false })}
                                                className="modal-h-antd modal-content-md "
                                                centered
                                            >
                                                {formFilterAdv}
                                            </Modal>
                                            {renderSidebarItem('Nâng cao', this.state.data_filter.indexOf(8) != -1, <HiOutlineUserGroup size={24} />, 'filter-adv', {
                                                onClick: () => this.setState({
                                                    visibleFilterOther: true
                                                })
                                            })}
                                        </React.Fragment>
                                    }
                                </React.Fragment> : null
                        }
                        {
                            this.props.UserLogin.role_action.indexOf('import_customer') > -1 ?
                                <React.Fragment>
                                    <Tooltip placement="right" title={"Tải lên tệp khách hàng"}>
                                        {renderSidebarItem('Import KH', false, <HiOutlineUpload size={24} />, 'filter-import', {
                                            onClick: () => this.setState({ visibleImportCustomer: true })
                                        })}
                                    </Tooltip>
                                    <Tooltip placement="right" title={"Đặt lịch"}>
                                        {renderSidebarItem('Đặt lịch', false, <HiOutlineCalendar size={24} />, 'filter-booking', {
                                            onClick: () => this.setState({ visibleBooking: true })
                                        })}
                                    </Tooltip>
                                </React.Fragment> : null
                        }
                        {
                            this.props.UserLogin.role_company.indexOf('sale') > -1 ?
                                <Tooltip placement="right" title={"Kết quả doanh thu"}>
                                    {renderSidebarItem('Doanh thu', false, <HiOutlineChartPie size={24} />, 'filter-revenue', {
                                        onClick: () => this.setState({ visibleResultSale: true })
                                    })}
                                </Tooltip> : null
                        }
                        <Tooltip placement="right" title={this.props.UserLogin.is_offline == 1 ? "Tắt chế độ bận" : "Kích hoạt chế độ bận"}>
                            {renderSidebarItem(this.props.UserLogin.is_offline == 1 ? 'Tắt bận' : 'Chế độ bận', false, <HiOutlineStatusOnline size={24} />, 'filter-status', {
                                className: this.props.UserLogin.is_offline == 1 ? "user-off" : "",
                                onClick: () => {
                                    if (this.props.UserLogin.is_offline == 0) {
                                        this.setState({ visibleCareHandle: true });
                                    } else {
                                        this.props.handleOffline(0);
                                    }
                                }
                            })}
                        </Tooltip>
                    </ul>

                    <div className='version'>v{config.version}</div>
                </div>
            </div>
        );
    }
}
